import axios from 'axios'
import { API_ADDRESS } from 'config'
import { PropertyData } from 'state/types'

interface CreateCouncilPropertiesResponse {
  status: string
  message: string
  errors?: string[]
}

export const getCouncilListingEdit = async (propertyId: string): Promise<PropertyData> => {
  // const url = `${API_ADDRESS}/admin/councils/csv-listings?suburbId=${suburbId}&ownerId=${ownerId}`
  const url = `${API_ADDRESS}/dashboard/property?id=${propertyId}`
  const { data } = await axios.get(url)
  // console.log(data)
  return data
}

export const updateListing = async (values): Promise<CreateCouncilPropertiesResponse> => {
  const ownerId = values.ownerId
  const jsonArrayIssues = []
  jsonArrayIssues.push(values)
  const url = `${API_ADDRESS}/admin/councils/upload-properties?ownerId=${ownerId}`
  console.log(jsonArrayIssues)
  console.log(ownerId)
  const { data } = await axios.post(url, jsonArrayIssues)
  return data
}
